import React, { useMemo, memo } from "react";
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";

// register lottie and define custom element
defineElement(lottie.loadAnimation);

export type LordIconTrigger =
  | "hover"
  | "click"
  | "loop"
  | "loop-on-hover"
  | "morph"
  | "morph-two-way";

export type LordIconColors = {
  primary?: string;
  secondary?: string;
};

export type LordIconProps = {
  src?: string;
  trigger?: LordIconTrigger;
  colors?: LordIconColors;
  delay?: number;
  size?: number;
  stroke?: number | string; // Allow string values like "light", "regular", "bold"
  isHover?: boolean;
  target?: string;
  disabled?: boolean;
  mainColor?: string;
};

export const LordIcon = memo(({
  colors,
  src,
  size,
  trigger,
  delay,
  stroke,
  isHover,
  target,
  disabled = false,
  mainColor,
}: LordIconProps) => {
  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
  }, []);
  return (
    <lord-icon
      colors={`primary:${
        disabled
          ? "#D9D9D9"
          : isHover
          ? colors?.primary
            ? colors?.primary
            : mainColor
            ? mainColor
            : "#274649"
          : mainColor
          ? mainColor
          : "#274649"
      },secondary:${
        disabled
          ? "#D9D9D9"
          : isHover
          ? colors?.secondary
            ? colors?.secondary
            : "#FFB073"
          : "#274649"
      }`}
      src={src}
      trigger={disabled ? "click" : trigger || "loop-on-hover"}
      delay={delay}
      // @ts-ignore - lord-icon accepts string values for stroke like "light", "regular", "bold"
      stroke={stroke || 40}
      style={{
        width: size ? size : 30,
        height: size ? size : 30,
      }}
      target={target}
    />
  );
});
